var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 247.12 247.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e7604f;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        opacity: .5;\n      }\n\n      .cls-2, .cls-5 {\n        fill: #fca64f;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #fccc4f;\n      }\n\n      .cls-6 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-7 {\n        isolation: isolate;\n      }\n\n      .cls-4 {\n        mix-blend-mode: screen;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 972.59,
    cy: 380.96,
    fx: 972.59,
    fy: 380.96,
    r: 266.57,
    gradientTransform: "translate(-976.11 -47.01) rotate(-15.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc6fe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fce24f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcb34f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M242.63,90.68c18.16,65.76-20.43,133.79-86.19,151.95-65.76,18.16-133.79-20.43-151.95-86.19C-13.67,90.68,24.92,22.65,90.68,4.49c65.76-18.16,133.79,20.43,151.96,86.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20.17,167.88C2.01,102.12,40.6,34.09,106.36,15.93c34.47-9.52,69.56-3.42,97.77,13.98C173.96,4.01,131.88-6.89,90.68,4.49,24.92,22.65-13.67,90.68,4.49,156.44c8.64,31.29,28.58,56.41,54.19,72.21-17.98-15.44-31.73-36.21-38.51-60.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138.52.93c-15.58-1.91-31.78-.88-47.85,3.56C56.47,13.94,29.64,36.9,14.3,66c.19.32.36.64.56.96,13.4,20.73,51,20.26,83.97-1.05C126.39,48.08,141.98,21.34,138.52.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.96,24.97c9.77,12.48,17.3,27.04,21.78,43.27,18.16,65.76-20.43,133.8-86.19,151.96-38.47,10.62-77.69,1.81-107.28-20.49,29.83,38.07,80.64,56.6,130.17,42.92,65.76-18.16,104.35-86.2,86.19-151.95-7.54-27.29-23.68-49.88-44.68-65.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M213.35,121.3c11.28,3.37,17.26,22.26,11.26,42.33-5.99,20.07-21.7,33.71-32.98,30.34-11.28-3.37-19.56-24.32-13.56-44.39,6-20.06,24.01-31.66,35.29-28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.31,35.85c3.63,6.67-5.57,18.68-20.54,26.82-14.97,8.13-30.05,9.31-33.67,2.64-3.63-6.67,5.57-18.68,20.54-26.82,14.97-8.13,30.05-9.31,33.67-2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.91,44.46c-12.67,6.88-21.16,16.53-21.29,23.38,5.84,3.58,18.52,1.69,31.15-5.17,12.66-6.88,21.16-16.53,21.29-23.38-5.84-3.58-18.52-1.69-31.15,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.83,98.08c8.98.72,15.22,14.25,13.94,30.23-1.28,15.97-9.61,28.33-18.59,27.61-8.98-.72-15.22-14.26-13.94-30.23,1.29-15.97,9.61-28.33,18.59-27.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48,128.22c1.07-13.36-3.13-24.99-9.79-28.86-6.6,3.5-11.96,13.79-12.97,26.34-1.07,13.36,3.13,24.99,9.79,28.87,6.61-3.5,11.97-13.79,12.98-26.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.81,129.83c8.63,2.58,11.91,17.12,7.32,32.47-4.59,15.35-15.31,25.71-23.94,23.13-8.63-2.58-11.91-17.12-7.32-32.47,4.59-15.35,15.31-25.71,23.94-23.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.35,159.63c3.8-12.71,2.19-24.83-3.36-30.1-7.76.82-16.2,10.28-20.13,23.43-3.8,12.71-2.19,24.83,3.36,30.11,7.77-.82,16.2-10.28,20.13-23.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.02,192.51c1.73-8.84,15.89-13.51,31.61-10.42,15.72,3.09,27.06,12.75,25.33,21.6-1.73,8.84-15.89,13.51-31.61,10.42-15.72-3.08-27.06-12.75-25.33-21.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.46,191.03c-12.68-2.48-24.32.07-29.27,5.78,1.89,7.48,11.96,14.71,25.15,17.29,12.67,2.49,24.32-.07,29.27-5.78-1.89-7.48-11.96-14.7-25.15-17.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.65,81.14c-5.76,10.05-22.98,11.02-38.47,2.15-15.48-8.87-23.37-24.21-17.61-34.27,5.76-10.05,22.98-11.02,38.47-2.15,15.49,8.87,23.37,24.21,17.61,34.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M186.04,46.88c-12.43-7.12-25.98-7.89-33.82-2.72-4.48,10.04,3.35,24.5,18.21,33.01,12.44,7.12,25.98,7.89,33.82,2.72,4.48-10.04-3.35-24.5-18.21-33.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.9,108.57c3.29,11.9-7.56,25.27-24.22,29.88-16.66,4.6-32.83-1.32-36.12-13.22-3.29-11.9,7.55-25.28,24.21-29.88,16.66-4.6,32.83,1.32,36.12,13.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.32,130.74c6.06,8.08,19.53,11.53,33.36,7.71,15.33-4.23,25.7-15.9,24.7-27-6.06-8.09-19.53-11.53-33.36-7.71-15.33,4.23-25.7,15.89-24.7,27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.33,109.99c2.07,16.14-10.87,31.22-29.18,36.28-17.58,4.85-35.36.7-42.45-9.35,3.97,13.72,23.55,20.3,43.92,14.67,20.47-5.65,34.23-23.83,27.82-42.01,0,0-.04.2-.11.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.73,199.96c-5.05,15.47-23.21,23.55-41.92,20.26-17.96-3.15-32.24-14.53-34.34-26.66-2.3,14.1,12.58,28.44,33.39,32.09,20.91,3.67,41.15-6.85,43.15-26.01,0,0-.12.16-.28.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.67,165.59c-16.03-2.8-26.61-19.62-26.02-38.61.56-18.23,9.8-33.98,21.5-37.78-14.28-.27-26.36,16.49-27.01,37.61-.66,21.23,12.63,39.75,31.89,39.01,0,0-.17-.1-.35-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.11,68.37c-3.92-12.4,6.48-27.82,23.2-36.6,16.05-8.43,33.39-9.69,41.33-3.46-5.42-9.98-24.77-10.19-43.36-.43-18.69,9.81-29.5,27.93-21.22,40.84,0,0,.02-.16.06-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.51,195.98c-14.93-6.47-21.29-25.3-16.27-43.62,4.81-17.59,17.47-30.75,29.74-31.71-13.82-3.6-29.49,9.87-35.06,30.26-5.6,20.48,2.99,41.6,21.89,45.38,0,0-.15-.13-.29-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.65,44.94c9.77-11.75,28.77-12.37,44.42-2.83,15.02,9.16,23.96,24.21,21.73,35.58,6.84-11.53-1.63-29.39-19.03-40-17.49-10.66-39.18-8.65-47.47,7.43,0,0,.16-.09.35-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.09,89.15c1.58,3.49-1.11,8.11-6.02,10.34-4.9,2.23-10.16,1.21-11.74-2.28-1.58-3.48,1.11-8.11,6.02-10.34,4.9-2.23,10.16-1.21,11.74,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.54,67.31c0,3.12-3.7,5.64-8.27,5.64s-8.27-2.52-8.27-5.64,3.7-5.64,8.27-5.64,8.27,2.53,8.27,5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.47,172.05c-1.67,3.31-6.95,4.01-11.8,1.57-4.85-2.44-7.43-7.11-5.77-10.42,1.67-3.31,6.95-4,11.8-1.56,4.85,2.44,7.43,7.11,5.77,10.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.22,112.34c-2.38.19-4.53-2.49-4.81-5.98-.28-3.49,1.43-6.47,3.81-6.66,2.38-.19,4.53,2.49,4.81,5.98.28,3.49-1.43,6.47-3.81,6.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.71,181.11c-.7-2.28,1.45-4.97,4.79-5.99,3.35-1.03,6.63-.01,7.33,2.28.7,2.28-1.45,4.96-4.79,5.99-3.35,1.03-6.63.01-7.33-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.54,109.5c-3.7.09-6.81-4.24-6.94-9.67-.13-5.43,2.77-9.9,6.47-9.99,3.7-.09,6.81,4.24,6.94,9.68.13,5.43-2.77,9.9-6.47,9.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.02,199.85c-3.04,2.11-8.02.2-11.11-4.27-3.09-4.47-3.13-9.8-.08-11.9,3.05-2.11,8.02-.2,11.11,4.27,3.09,4.46,3.13,9.79.08,11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.07,198.44c-2.35-2.86-.85-7.98,3.35-11.42,4.2-3.44,9.51-3.92,11.86-1.05,2.35,2.87.84,7.98-3.36,11.42-4.2,3.44-9.51,3.91-11.86,1.05Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceMoon);
export default __webpack_public_path__ + "static/media/SPACE_MOON.080a5c97c62d44cf0cafff09071978a8.svg";
export { ForwardRef as ReactComponent };